export default "__VITE_ASSET__D$467Vcy__"